import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ILegacyPathRedirect {
  // Old base path, e.g. `/optimize/reams`
  fromBasePath: string;
  // New base path, e.g. `/optimize/rent-navigator`
  toBasePath: string;
}

const LegacyPathRedirect: React.FC<ILegacyPathRedirect> = ({
  fromBasePath,
  toBasePath,
}) => {
  const { pathname, search, hash } = useLocation();

  const restOfPath = pathname.startsWith(fromBasePath)
    ? pathname.slice(fromBasePath.length)
    : '';

  return <Navigate to={`${toBasePath}${restOfPath}${search}${hash}`} replace />;
};

export default LegacyPathRedirect;
